<template>
  <div class="scoped-list">
    <Tabs v-model="tab" @on-click="getList">
      <template slot="extra">
        <Dropdown trigger="click" transfer @on-click="onActive">
            <Button size="small" :disabled="loading">{{ $t('name.cex.list.button_active') }}</Button>
            <DropdownMenu slot="list">
              <DropdownItem name="ok" v-if="tab == 'tab0'">{{ $t('name.cex.list.button_ok') }}</DropdownItem>
              <DropdownItem name="no" v-if="tab == 'tab0'">{{ $t('name.cex.list.button_no') }}</DropdownItem>
              <DropdownItem name="pdf" v-if="tab == 'tab1'">{{ $t('name.cex.list.button_pdf') }}</DropdownItem>
            </DropdownMenu>
        </Dropdown>
      </template>
      <TabPane :label="$t('name.cex.list.tab0') + '(' + pay.length + ')'" name="tab0">
        <div class="list">
          <List>
            <ListItem class="item" v-for="item in pay" :key="item.id">
              <ListItemMeta :title="item.name">
                <template slot="description">
                  <div class="content">
                    {{ item.data_city + ' - ' + item.data_name }}
                  </div>
                </template>
              </ListItemMeta>
              <template slot="extra">
                <a @click="ok(item.id)">
                  {{ $t('name.cex.list.active_order') }}
                </a>
                <Divider type="vertical" style="margin: 0 3px" />
                <Poptip
                  confirm
                  :title="$t('name.cex_order.active_no_message')"
                  @on-ok="no(item.id)"
                  placement="top-end"
                  transfer
                >
                  <a>{{ $t('name.cex.list.active_no') }}</a>
                </Poptip>
              </template>
              <div class="message" v-if="item.message">
                {{ item.message == 'loading' ? $t('name.cex.list.loading') : item.message }}
              </div>
            </ListItem>
          </List>
        </div>
      </TabPane>
      <TabPane :label="$t('name.cex.list.tab1') + '(' + day.length + ')'" name="tab1">
        <div class="list">
          <List>
            <ListItem class="item" v-for="item in day" :key="item.id">
              <ListItemMeta :title="item.name">
                <template slot="description">
                  <div class="content">
                    {{ item.data_city + ' - ' + item.data_name }}
                  </div>
                  <div class="code">
                    {{ item.waybill }}
                  </div>
                </template>
              </ListItemMeta>
              <template slot="extra">
                <div style="text-align: right">
                  <a @click="pdf(item)">
                    {{ $t('name.cex.list.active_pdf') }}
                  </a><br>
                  <Time :time="item.updated_at * 1000" class="time" />
                </div>
              </template>
            </ListItem>
          </List>
        </div>
      </TabPane>
    </Tabs>
  </div>
</template>
<script>
import http from '@/http'
import JSZip from 'jszip'
import { getTime } from '@/tools/utlis'
import { user, no, ok } from '@/api/cex_order'

export default {
  data() {
    return {
      loading: false,
      tab: 'tab0',
      pay: [],
      day: []
    }
  },
  created() {
    this.getList()
  },
  methods: {
    // 获取所有数据
    getList() {
      this.getPay()
      this.getDay()
    },
    // 获取已支付列表
    getPay() {
      user({ status: 0, all: 1 }, false).then(res => {
        this.pay = res
      })
    },
    // 获取今日订单
    getDay() {
      // 今日时间
      const day = getTime(new Date(new Date().setHours(0, 0, 0, 0)))
      const update_time = [day, 9999999999]
      user({ update_time, status: 1, all: 1 }, false).then(res => {
        this.day = res
      })
    },
    // 关闭订单
    no(id) {
      return new Promise(resolve => {
        no(id).then(res => {
          this.getList()
          this.$Message.success(this.$t('message.' + res.message))
          resolve(true)
        }).catch(res => {
          this.$Message.error(this.$t('message.' + res.message))
          resolve(false)
        })
      });
    },
    // 确认订单
    ok(id) {
      return new Promise(resolve => {
        ok(id).then(res => {
          this.getList()
          this.$Message.success(this.$t('message.' + res.message))
          resolve(true)
        }).catch(res => {
          this.$Message.error(this.$t('message.' + res.message))
          resolve(false)
        })
      });
    },
    // pdf
    pdf(data) {
      window.open(data.pdf, '_blank')
    },
    // 批量确认
    async okList(){
      // 传入缓存数据，改变列表时，不要因为更新列表而改变循环指针
      const data = Object.assign([], this.pay)
      
      // 循环缓存列表
      for (var i in data) {
        await ok(data[i].id)
        // 更新列表
        this.getList()
      }
      
      this.loading = false
    },
    // 批量关闭
    async noList() {
      // 弹出数组
      const item = this.pay.shift()
      if(item) {
        await no(item.id)
        // 继续执行
        return this.noList()
      }
      // 更新列表
      this.getList()
      this.loading = false
    },
    // 批量下载PDF
    async pdfList(){
      // 新建压缩包
      const zip = new JSZip
      
      // 循环请求PDF
      for (const i in this.day) {
        // 请求PDF
        const pdf = await http.get('/../' + this.day[i].pdf, {
          responseType: 'blob'
        })
        
        // 加入ZIP
        zip.file(this.day[i].waybill + '.pdf', pdf)
      }
      
      // 开始压缩
      zip.generateAsync({
        type: "blob",
        compression: "DEFLATE",
        compressionOptions: { level: 1 }
      }).then(content => {
        const blob = new Blob([content], { type: "application/zip" });
        const link = document.createElement("a")
        const url = URL.createObjectURL(blob)
        link.href = url
        link.download = "pdf.zip"
        link.click()
        URL.revokeObjectURL(url)
        this.loading = false
      });
    },
    // 批量操作
    onActive(name) {
      switch(name) {
        case 'ok': 
          // 循环确认
          this.$Modal.confirm({
            title: this.$t('name.cex.list.button_ok'),
            content: this.$t('name.cex.list.button_ok_message'),
            onOk: async () => {
              this.loading = true
              this.okList()
            }
          });
          return
        case 'no':
          // 循环关闭
          this.$Modal.confirm({
            title: this.$t('name.cex.list.button_no'),
            content: this.$t('name.cex.list.button_no_message'),
            onOk: () => {
              this.loading = true
              this.noList()
            }
          });
          return
        case 'pdf':
          this.loading = true
          this.pdfList()
          return
      }
    }
  },
};
</script>
<style lang="less" scoped>
  @import '@/style/app.less';

  .scoped-list{
    padding-top: 25px;
    
    .active{
      text-align: right;  
    }
    
    .list{
      height: 470px;
      overflow: auto;
      
      .item{
        flex-wrap: wrap;
      }
      
      .content{
        overflow: hidden;
        height: 22px;
      }
      
      .code{
        line-height: 20px;
        padding-top: 5px;
        color: @color;
      }
      
      .message{
        width: 100%;
        order: 3;
        color: @color-warning;
        line-height: 18px;
        margin-top: 6px;
        padding: 6px 10px;
        background: @background;
        border-radius: 6px;
      }
      
      .time{
        color: @color-border;
      }
    }
  }
</style>